import React from "react";
import { useLocation } from "react-router-dom";

const HasNavigatedCtx = React.createContext();
HasNavigatedCtx.displayName = "HasNavigatedProviderCtx";

const HasNavigatedProvider = ({ children }) => {
  const { pathname: route } = useLocation();
  const firstRender = React.useRef(true);
  const [links, setLink] = React.useState({ prevLink: null, currLink: route });

  React.useLayoutEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    setLink(({ currLink }) => ({
      prevLink: currLink,
      currLink: route,
    }));
  }, [route]);

  const hasNavigated = !(links.prevLink === null && links.currLink !== "/");

  return (
    <HasNavigatedCtx.Provider value={hasNavigated}>
      {children}
    </HasNavigatedCtx.Provider>
  );
};

const useHasNavigated = () => React.useContext(HasNavigatedCtx);

export { HasNavigatedProvider, useHasNavigated };
